import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Typography } from '@mui/material';

import { EmptyWorkspace } from 'pages/Workspace/components/EmptyWorkspace/EmptyWorkspace';
import { WorkspaceBusinessPlans } from 'pages/Workspace/components/WorkspaceBusinessPlans/WorkspaceBusinessPlans';
import { WorkspaceLoader } from 'pages/Workspace/components/WorkspaceLoader/WorkspaceLoader';

import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';
import LoadingDecorator from 'components/LoadingDecorator';

import { IWorkspaceLayoutProps } from '../types';

import styles from './DesktopLayout.module.scss';

export const DesktopLayout: FC<IWorkspaceLayoutProps> = ({ data, isLoading, error }) => {
  const { t } = useTranslation();

  return (
    <Container className={styles.wrapper}>
      <ContentWrapper sx={{ marginBottom: 2 }}>
        <Typography variant="h1" sx={{ fontSize: '24px', fontWeight: '700' }}>
          {t('myWorkspace')}
        </Typography>
      </ContentWrapper>

      <LoadingDecorator data={data} loading={isLoading} error={error} loadingComponent={<WorkspaceLoader />}>
        {(businessPlans) =>
          businessPlans.total ? <WorkspaceBusinessPlans businessPlan={businessPlans} /> : <EmptyWorkspace />
        }
      </LoadingDecorator>
    </Container>
  );
};
